$(document).ready(function () {

  // ✅ AFB — libera o menu após o DOM estar pronto (ANTI-FLASH)
  // CRÍTICO: aplica no HTML + BODY (não pode depender do desktop)
  document.documentElement.classList.add('afb-menu-ready');
  document.body.classList.add('afb-menu-ready');

  // ⛔️ BLOQUEIA NO MOBILE / TABLET
  // A LÓGICA ORIGINAL DO TEMA roda APENAS quando a viewport é desktop (>= 992px)
  if (!window.matchMedia('(min-width: 992px)').matches) return;

  // ==========================================================
  // MENU MOBILE — LÓGICA ORIGINAL DO TEMA (DESKTOP ONLY)
  // ==========================================================

  // Adiciona o botão de abrir/fechar nos itens que têm filho
  $("#ma-mobilemenu .had_child, ul.mobilemenu li span.button-view1, ul.mobilemenu li span.button-view2").each(function () {
    $(this).append(
      '<span class="ttclose ttnavigation"><a href="javascript:void(0)"></a></span>'
    );
  });

  // Mantém submenus abertos para itens já ativos
  $("ul.mobilemenu li.active").each(function () {
    $(this).children().next("ul").css('display', 'block');
  });

  // Esconde todos os submenus por padrão
  $("ul.mobilemenu li ul").hide();

  // ==========================================================
  // NÍVEL 2 — botão-view1
  // ==========================================================
  $('span.button-view1 span').on('click', function () {
    var varche = $(this).hasClass('ttopen');

    if (!varche) {
      $(this).addClass('ttopen').removeClass('ttclose');
      $(this).parent().parent().find('ul.level2').slideDown();
    } else {
      $(this).removeClass('ttopen').addClass('ttclose');
      $(this).parent().parent().find('ul.level2').slideUp();
    }
  });

  // ==========================================================
  // NÍVEL 3 — botão-view2
  // ==========================================================
  $('span.button-view2 span').on('click', function () {
    var varche = $(this).hasClass('ttopen');

    if (!varche) {
      $(this).addClass('ttopen').removeClass('ttclose');
      $(this).parent().parent().find('ul.level3').slideDown();
    } else {
      $(this).removeClass('ttopen').addClass('ttclose');
      $(this).parent().parent().find('ul.level3').slideUp();
    }
  });

  // ==========================================================
  // MENU ORIGINAL (DESKTOP)
  // ==========================================================
  $('.originalmenu span.ttnavigation').on('click', function () {
    var varche = $(this).hasClass('ttopen');

    if (!varche) {
      $(this).addClass('ttopen').removeClass('ttclose');
      $(this).parent().children('ul').slideDown();
    } else {
      $(this).removeClass('ttopen').addClass('ttclose');
      $(this).parent().children('ul').slideUp();
    }
  });

  // ==========================================================
  // AFB — OBSERVAÇÃO IMPORTANTE
  // ==========================================================
  // O clique do botão hambúrguer agora é controlado pelo
  // mobile-menu-afb.liquid.
  // O handler antigo foi removido para evitar conflitos.

});
